
<div>
  <div v-if="loading">
    <slot/>
  </div>
</div>
